import { useEffect } from 'react'
import { X } from 'lucide-react'

// Простой лайтбокс для просмотра картинки-вложения: затемнение, Escape и клик-вне закрывают.
export function Lightbox({ url, onClose }: { url: string | null; onClose: () => void }) {
  useEffect(() => {
    if (!url) return
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [url, onClose])

  if (!url) return null

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox-close" onClick={onClose} aria-label="Закрыть">
        <X size={22} />
      </button>
      <img src={url} alt="" onClick={(event) => event.stopPropagation()} />
    </div>
  )
}
